import React from "react";

class ConnectionBG extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="131.59"
        height="111.375"
        viewBox="0 0 131.59 111.375"
      >
        <path
          id="#tariffsSlideControllBg"
          data-name="Shape 8 copy 2"
          className="cls-1"
          d="M1077,376c12.99-17.98,89.62-21.683,105-3,19.91,24.179,17.36,64.469,3,79-28.23,28.574-78.7,22.047-94,8C1075.03,445.343,1049.32,414.305,1077,376Z"
          transform="translate(-1064.75 -360.625)"
          fill="currentColor"
        />

        <text
          y="50"
          transform="translate(64)"
          fill="currentColor"
          fontFamily="sans-serif"
          fontSize="15"
        >
          <tspan x="0" textAnchor="middle">
            «Контроль»
          </tspan>
          <tspan
            x="0"
            textAnchor="middle"
            dy="15"
            id="tarrifsSlideTariffPrice"
          >
            2000 руб/месяц
          </tspan>
        </text>
      </svg>
    );
  }
}

export default ConnectionBG;
